<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :sticky="true"
    >
      <Slide v-if="slideList && slideList.length > 0" :slideList="slideList" />
      <div v-for="item in newsList" :key="item.id">
        <NewsCell
          v-if="
            item.listType == 0 ||
            item.listType == 4 ||
            item.listType == 6 ||
            item.listType == 7
          "
          :item="item"
        />
        <TopicCell
          v-if="item.listType == 1 || item.listType == 5"
          :item="item"
        />
        <NoPicCell v-if="item.listType == 8" :item="item" />
        <PicturesCell v-if="item.listType == 2" :item="item" />
        <van-swipe
          v-if="item.listType == 11"
          class="advert"
          :autoplay="3000"
          lazy-render
        >
          <van-swipe-item v-for="advert in item.items" :key="advert.id">
            <van-image width="100%" height="auto" :src="advert.img" />
          </van-swipe-item>
        </van-swipe>
      </div>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import { Swipe, SwipeItem, List, PullRefresh, Image as VanImage } from "vant";
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import NewsCell from "../components/NewsCell.vue";
import TopicCell from "../components/TopicCell.vue";
import NoPicCell from "../components/NoPicCell.vue";
import Slide from "../components/Slide.vue";
import PicturesCell from "../components/PicturesCell.vue";
export default {
  name: "NewsList",
  props: {
    category: Object,
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [VanImage.name]: VanImage,
    NewsCell,
    TopicCell,
    Slide,
    PicturesCell,
    NoPicCell,
  },
  setup(props) {
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const page = ref(1);

    const store = useStore();

    const onLoad = async () => {
      const params = {
        categoryId: props.category.redirectCategoryId,
        page: page.value,
        pageSize: 4,
      };
      const success = await store.dispatch("getNewsList", {
        params,
        loading,
        finished,
        refreshing,
      });
      if (success) {
        page.value++;
      }
    };

    const onRefresh = () => {
      // 清空列表数据
      finished.value = false;
      loading.value = true;
      page.value = 1;
      onLoad();
    };

    const onManRefresh = () => {
      refreshing.value = true;
      finished.value = false;
      loading.value = true;
      page.value = 1;
      onLoad();
    };

    onMounted(() => {
      // onRefresh();
    });

    return {
      newsList: computed(
        () => store.state.newsList[props.category.redirectCategoryId]
      ),
      slideList: computed(
        () => store.state.slideList[props.category.redirectCategoryId]
      ),
      onLoad,
      onRefresh,
      onManRefresh,
      loading,
      finished,
      refreshing,
    };
  },
};
</script>

<style lang="scss" scoped>
.slide {
  width: 100vw;
  height: 56vw;
  .slide-item {
    width: 100vw;
    height: 100%;
  }
}
.advert {
  width: 100vw;
}
</style>
